export const isAreaUnit = (unit) => ["sqft", "square_feet"].includes(unit);

// Same coverage-per-100-sqft rule used by the customer Add to cart modal.
export function resolveAddonQuantity(addon, serviceUnit, area) {
  if (!isAreaUnit(serviceUnit) || !isAreaUnit(addon.price_type) || addon.unavailable) {
    return Number(addon.quantity || 0);
  }
  if (!Number.isFinite(Number(area)) || Number(area) <= 0) return 0;
  return Math.max(1, Math.ceil((Number(addon.baseQuantity || 1) / 100) * Number(area)));
}